const serviceData = [
  {
    id: 1,
    title: "Rent a car",
    icon: "ri-map-pin-2-line",
    desc: "Car rental services offer flexible, short-term access to vehicles for business trips, vacations or daily needs without the cost of ownership. Customers can choose from economy cars, SUV, vans and luxury models, with options for self-drive or chauffeur-driven rentals.",
  },

  {
    id: 2,
    title: "Car Clinic",
    icon: "ri-community-line",
    desc: "Our Services helps keep vehicles clean, shiny and well-maintained both inside and out. Our services include exterior wash, tire and rim cleaning, interior vacuuming, dashboard polishing and window detailing.",
  },

  {
    id: 4,
    title: "Barbershop",
    icon: "ri-timer-flash-line",
    desc: "Our barbershop is more than just a place for haircuts-it's a space for style, grooming and community. We offer services like fades, trims, beard shaping, line-ups and hot towel shaves using modern tools and classic techniques.",
  },
 
];

export default serviceData;
